import React from 'react';

const FactorTypeSelect = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  return (
    <div className={'divgroup'}>
      <label htmlFor="setSendData_factorType">نوع فاکتور</label>
      <select
        id={'setSendData_factorType'}
        className="form-select"
        value={setSendData.factorType}
        onChange={(e) => setSendData({factorType: e.target.value})}
        required
      >
        <option value="factor">فاکتور</option>
        <option value="draft">پیش فاکتور</option>
      </select>
    </div>
  );
};

export default FactorTypeSelect;
